module.exports = __webpack_public_path__ + "img/bsAttrCard_icon_03.32a56c46.png";